module.exports = __webpack_public_path__ + "img/2.52bc9fa7.png";